import { getFirebaseInstances } from '../../Firebase';
import { getGtagInstances } from '../../GTag';
import { AppDataSync, InstancesStore } from '../../Analytics/context';
import { AnalyticsModulesInitialization } from '../Analytics.types';
import { getClarityInstances } from '../../Clarity/Initializer';

const analyticsModulesInit: AnalyticsModulesInitialization = {
  gtag: (appDataSync: AppDataSync) => getGtagInstances(appDataSync),
  firebase: (appDataSync: AppDataSync) => getFirebaseInstances(appDataSync),
  clarity: (appDataSync: AppDataSync) => getClarityInstances(appDataSync),
};

export const getAnalyticsInstances = (appDataSync: AppDataSync) => {
  let analyticsInstances: InstancesStore = {};

  Object.keys(analyticsModulesInit).forEach(moduleName => {
    const appDataSyncModule = appDataSync[moduleName as keyof AppDataSync];

    if (appDataSyncModule) {
      const instancesByModule =
        analyticsModulesInit[
          moduleName as keyof AnalyticsModulesInitialization
        ]?.(appDataSync) || {};

      analyticsInstances = { ...analyticsInstances, ...instancesByModule };
    }
  });

  return analyticsInstances;
};
